import React, { useState } from 'react'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import Resx from '@/components/Resx'
import { TabContent, TabNavItems, TabPane } from '@/components/tabs'
import RsaKeyPolicy from '@/internal-app/pages/administration/passwordPolicy/RsaKeyPolicy'
import PasswordPolicyPasswordTab from '@/internal-app/pages/administration/passwordPolicy/PasswordPolicyPasswordTab'

function PasswordPolicy () {
  const [ activeTab, setActiveTab ] = useState('1')

  return <Main>
    <MainTop>
      <MainTopTitle><Resx name='Security.PasswordPolicy' /></MainTopTitle>
    </MainTop>
    <MainBody>
      <TabNavItems
        buttonView
        activeTabId={activeTab}
        onClick={setActiveTab}
        items={[
          { id: '1', text: 'Security.Password' },
          { id: '2', text: 'Security.RsaKeyPolicy' } ]} />
      <TabContent activeTab={activeTab} renderActiveOnly>
        <TabPane tabId='1'>
          <PasswordPolicyPasswordTab />
        </TabPane>
        <TabPane tabId='2'>
          <RsaKeyPolicy />
        </TabPane>
      </TabContent>
    </MainBody>
  </Main>
}

export default PasswordPolicy



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/passwordPolicy/PasswordPolicy.js